module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Done-circle-3e2a1d3177ae2ca16126d2c6404f469c.svg";